import { render } from "./AddChannelsModal.vue?vue&type=template&id=61d8c0e5&scoped=true"
import script from "./AddChannelsModal.vue?vue&type=script&lang=js"
export * from "./AddChannelsModal.vue?vue&type=script&lang=js"

import "./AddChannelsModal.vue?vue&type=style&index=0&id=61d8c0e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d8c0e5"],['__file',"src/components/modals/AddChannelsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d8c0e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d8c0e5', __exports__)) {
    api.reload('61d8c0e5', __exports__)
  }
  
  module.hot.accept("./AddChannelsModal.vue?vue&type=template&id=61d8c0e5&scoped=true", () => {
    api.rerender('61d8c0e5', render)
  })

}


export default __exports__